import api from './api';
import { TaskRule, TaskRuleCreate, TaskRuleUpdate } from '../types/taskRule';

export const taskRuleService = {
  async getAll(tenantId: number): Promise<TaskRule[]> {
    const response = await api.get(`/task-rules/?tenant_id=${tenantId}`);
    return response.data;
  },

  async getById(id: number): Promise<TaskRule> {
    const response = await api.get(`/task-rules/${id}`);
    return response.data;
  },

  async create(data: TaskRuleCreate): Promise<TaskRule> {
    const response = await api.post('/task-rules/', data);
    return response.data;
  },

  async update(id: number, data: TaskRuleUpdate): Promise<TaskRule> {
    const response = await api.put(`/task-rules/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/task-rules/${id}`);
  },
};
